import MobileWalletsFilter from '../../../../components/MobileFilter/MobileWalletsFilter';
import SearchTable, {
  IMobileFilterProps,
  IMobileSearchButton,
} from '../../../../components/SearchTable/SearchTable';
import MobileAnalyzeWallet from './AnalyzeWallet';
import WalletTableMobile from './WalletTable';

const WalletSearchPanel = ({ onBack }: { onBack(): void }) => {
  const renderTable = (
    search: string,
    onChildMount: (data: IMobileFilterProps) => void,
    onBack: () => void
  ) => (
    <WalletTableMobile
      inputSearch={search}
      onMount={onChildMount}
      onBack={onBack}
    />
  );

  const renderFilterOptions = (props: IMobileFilterProps) => (
    <MobileWalletsFilter {...props} />
  );

  const renderSearchButton = (props: IMobileSearchButton) => (
    <MobileAnalyzeWallet {...props} />
  );

  return (
    <SearchTable
      tableTitle='Advanced wallet search'
      filterTitle='Select chain'
      renderChildren={renderTable}
      renderFilterOptions={renderFilterOptions}
      renderSearchButton={renderSearchButton}
      onBack={onBack}
    />
  );
};

export default WalletSearchPanel;
